// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.knowledge-modal-title {
    margin: 0 !important;
    margin-bottom: 30px !important;
    font-size: 30px;
    font-weight: 600;
}

.knowledge-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 4px;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 12px;
}

.knowledge-modal-header h2 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    color: #333;
}

.knowledge-modal-header-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: calc(100% - 50px);
}

.knowledge-modal-type-icon {
    color: #5616ea;
    margin-right: 10px;
    flex-shrink: 0;
    vertical-align: middle;
    position: relative;
    top: -1px;
}

.knowledge-modal-external-link {
    color: #999;
    margin-left: 10px;
    font-size: 0.85rem;
    flex-shrink: 0;
    transition: color 0.2s;
}

.knowledge-modal-external-link:hover {
    color: #5616ea;
}

.knowledge-modal-close {
    background: none;
    border: none;
    font-size: 1.25rem;
    color: #666;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    transition: background-color 0.2s;
}

.knowledge-modal-close:hover {
    background-color: #f0f0f0;
    color: #333;
}

.knowledge-modal-body {
    flex: 1 1;
    overflow-y: auto;
    margin-top: 8px;
    min-height: 60px;
    background-color: #fafafa;
    border-radius: 10px;
    border: 1px solid #ebebeb;
}

.knowledge-modal-body::-webkit-scrollbar {
    width: 6px;
}

.knowledge-modal-body::-webkit-scrollbar-track {
    background: transparent;
}

.knowledge-modal-body::-webkit-scrollbar-thumb {
    background-color: #d0d0d0;
    border-radius: 3px;
}

.knowledge-modal-body::-webkit-scrollbar-thumb:hover {
    background-color: #b0b0b0;
}

.knowledge-plain-text {
    margin: 0;
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: 0.9rem;
    line-height: 1.75;
    color: #000000;
    letter-spacing: 0.01em;
    padding: 10px;
}
/* Truncated-preview notice (knowledgePreview.js): sits above the text body
   when only the first part of a large item is shown. */
.knowledge-preview-notice {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-top: 8px;
    padding: 8px 12px;
    border-radius: 8px;
    background-color: #f3eeff;
    border: 1px solid #e2d6ff;
    color: #3d2a80;
    font-size: 0.85rem;
}

.knowledge-preview-notice-btn {
    background: #5e1bff;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 6px 12px;
    font-size: 0.85rem;
    font-family: inherit;
    cursor: pointer;
    white-space: nowrap;
}

.knowledge-preview-notice-btn:hover {
    background: #4a12d6;
}

.knowledge-preview-notice-hint {
    color: #6b5aa0;
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/knowledgeModal.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,qBAAqB;IACrB,iFAAiF;IACjF,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,aAAa;AACjB;AACA;uDACuD;AACvD;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB","sourcesContent":[".knowledge-modal-title {\r\n    margin: 0 !important;\r\n    margin-bottom: 30px !important;\r\n    font-size: 30px;\r\n    font-weight: 600;\r\n}\r\n\r\n.knowledge-modal-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding-bottom: 4px;\r\n    border-bottom: 1px solid #e0e0e0;\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.knowledge-modal-header h2 {\r\n    margin: 0;\r\n    font-size: 1.25rem;\r\n    font-weight: 600;\r\n    display: flex;\r\n    align-items: center;\r\n    color: #333;\r\n}\r\n\r\n.knowledge-modal-header-title {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    max-width: calc(100% - 50px);\r\n}\r\n\r\n.knowledge-modal-type-icon {\r\n    color: #5616ea;\r\n    margin-right: 10px;\r\n    flex-shrink: 0;\r\n    vertical-align: middle;\r\n    position: relative;\r\n    top: -1px;\r\n}\r\n\r\n.knowledge-modal-external-link {\r\n    color: #999;\r\n    margin-left: 10px;\r\n    font-size: 0.85rem;\r\n    flex-shrink: 0;\r\n    transition: color 0.2s;\r\n}\r\n\r\n.knowledge-modal-external-link:hover {\r\n    color: #5616ea;\r\n}\r\n\r\n.knowledge-modal-close {\r\n    background: none;\r\n    border: none;\r\n    font-size: 1.25rem;\r\n    color: #666;\r\n    cursor: pointer;\r\n    padding: 4px 8px;\r\n    border-radius: 4px;\r\n    transition: background-color 0.2s;\r\n}\r\n\r\n.knowledge-modal-close:hover {\r\n    background-color: #f0f0f0;\r\n    color: #333;\r\n}\r\n\r\n.knowledge-modal-body {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    margin-top: 8px;\r\n    min-height: 60px;\r\n    background-color: #fafafa;\r\n    border-radius: 10px;\r\n    border: 1px solid #ebebeb;\r\n}\r\n\r\n.knowledge-modal-body::-webkit-scrollbar {\r\n    width: 6px;\r\n}\r\n\r\n.knowledge-modal-body::-webkit-scrollbar-track {\r\n    background: transparent;\r\n}\r\n\r\n.knowledge-modal-body::-webkit-scrollbar-thumb {\r\n    background-color: #d0d0d0;\r\n    border-radius: 3px;\r\n}\r\n\r\n.knowledge-modal-body::-webkit-scrollbar-thumb:hover {\r\n    background-color: #b0b0b0;\r\n}\r\n\r\n.knowledge-plain-text {\r\n    margin: 0;\r\n    white-space: pre-wrap;\r\n    word-wrap: break-word;\r\n    font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\r\n    font-size: 0.9rem;\r\n    line-height: 1.75;\r\n    color: #000000;\r\n    letter-spacing: 0.01em;\r\n    padding: 10px;\r\n}\r\n/* Truncated-preview notice (knowledgePreview.js): sits above the text body\r\n   when only the first part of a large item is shown. */\r\n.knowledge-preview-notice {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 12px;\r\n    margin-top: 8px;\r\n    padding: 8px 12px;\r\n    border-radius: 8px;\r\n    background-color: #f3eeff;\r\n    border: 1px solid #e2d6ff;\r\n    color: #3d2a80;\r\n    font-size: 0.85rem;\r\n}\r\n\r\n.knowledge-preview-notice-btn {\r\n    background: #5e1bff;\r\n    color: #fff;\r\n    border: none;\r\n    border-radius: 6px;\r\n    padding: 6px 12px;\r\n    font-size: 0.85rem;\r\n    font-family: inherit;\r\n    cursor: pointer;\r\n    white-space: nowrap;\r\n}\r\n\r\n.knowledge-preview-notice-btn:hover {\r\n    background: #4a12d6;\r\n}\r\n\r\n.knowledge-preview-notice-hint {\r\n    color: #6b5aa0;\r\n    white-space: nowrap;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
